import React, { useState } from 'react';
import { useMsal } from "@azure/msal-react";
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';
import styles from '../FollowUpPopUp/FollowUpPopUp.module.css';
import DatePicker from '../DatePicker/DatePicker';
import { useDispatch } from '../../redux/store';
import { setClientFollowUpDate, postClientLogbook } from '../../redux/slices/client';

const ClientFollowUpPopUp = ({ isVisible, onClose, onSubmit, clientID, commentText }) => {
  const { accounts } = useMsal();
  const account = accounts[0];
  const dispatch = useDispatch();

  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  const handleDatesChange = (ranges) => {
    const { startDate } = ranges || {};
    if (startDate) {
      // ranges.startDate arrives as an ISO string from DatePicker
      const start = new Date(startDate);
      setDateRange({ startDate: start, endDate: start });
    }
  };

  const handleSubmit = async () => {
    const formattedStartDate = dateRange.startDate.toISOString();
    await dispatch(setClientFollowUpDate(clientID, formattedStartDate, account.username));
    // Also post to logbook with activity "Person of Interest" and a generated comment
    const humanDate = new Date(formattedStartDate).toLocaleDateString('en-GB');
    const extra = commentText && commentText.trim() ? ` ${commentText.trim()}` : '';
    const autoComment = `${humanDate} - Follow-up set for Person of Interest.${extra}`;
    await dispatch(postClientLogbook(clientID, 'Person of Interest', autoComment, account.username));
    if (typeof onSubmit === 'function') onSubmit();
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <p className={styles.text}>Please select a follow up date</p>
        <div>
          <DatePicker
            initialDate={dateRange.startDate}
            onDatesChange={item => handleDatesChange(item)}
            visibleIcon={true}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
          <div style={{ width: '74px', height: '25px' }}>
            <button className={buttonStyles.YesButtonComponentStyling} onClick={handleSubmit}>SUBMIT</button>
          </div>
          <div style={{ width: '74px', height: '25px', marginLeft: '10px' }}>
            <button className={buttonStyles.NoButtonComponentStyling} onClick={onClose}>CANCEL</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientFollowUpPopUp;


